import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Comment obtenir un pardon pour alcool au volant au Québec?"
            description="Vous avez été reconnu coupable de conduite avec les facultés affaiblies par l’alcool et souhaitez obtenir un pardon ? Nous vous expliquons comment l’obtenir!"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour obtenir un pardon">
            <p>
                Il est possible d’en certains cas d’obtenir le pardon après
                avoir été reconnu coupable d’alcool au volant. Pour obtenir le
                pardon, il faudra suivre les étapes suivantes:
            </p>
            <ul>
                <li>Vérifier votre éligibilité,</li>
                <li>Regrouper les documents nécessaires,</li>
                <li>Remplir les formulaires obligations, </li>
                <li>Déposer votre demande, et </li>
                <li>Attendre la décision.</li>
            </ul>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Demande de pardon pour conduite avec facultés affaiblies!"
                    alt=""
                />
            </p>
            <p>
                Si votre demande de pardon est acceptée, cette dernière ne
                disparaît pas. Néanmoins, puisque vous n’aurez plus de casier
                judiciaire, les employeurs et propriétaires de logement locatif
                ne pourront pas prendre connaissance de l’infraction.
            </p>
            <ul>
                <li>
                    <strong>
                        Grâce à Avocats Alcool au volant, voyez comment obtenir
                        le pardon pour conduite avec les facultés affaiblies!
                    </strong>
                </li>
            </ul>
            <h2>
                <strong>
                    Qu’est-ce qu’une demande de pardon pour conduite avec
                    facultés affaiblies par l’alcool ?
                </strong>
            </h2>
            <p>
                Une demande de pardon pour conduite avec les facultés affaiblies
                est une procédure légale qui permet à la personne coupable de
                voir son casier judiciaire effacé des vérifications courantes.
            </p>
            <table>
                <tr>
                    <td>
                        <h4>
                            <strong>Attention! </strong>Le pardon n’est pas une
                            absolution est donc, il n’efface pas votre
                            infraction.
                        </h4>
                        <p>
                            L'infraction reste dans les archives de la
                            Gendarmerie royale du Canada, mais elle devient
                            confidentielle et n’apparaît plus lors des
                            vérifications de casier judiciaire réalisées par des
                            employeurs ou d’autres entités, sauf dans des
                            circonstances spécifiques où l'accès à ces
                            informations est requis, par exemple, pour des
                            raisons de sécurité publique.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                L’objectif d'une demande de pardon n'est pas d'effacer les
                faits, mais de{' '}
                <strong>limiter les conséquences de l'infraction.</strong>
            </p>
            <p>
                Une fois que la demande est acceptée, la personne bénéficie
                d'une forme de réhabilitation.Le casier judiciaire ne sera plus
                accessible au public, lui permettant ainsi de se réintégrer plus
                facilement dans la société sans être constamment pénalisé pour
                un acte passé.
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Pourquoi faire une demande de pardon?"
                    alt=""
                />
            </p>
            <p>
                Puisque l’infraction se trouve toujours dans les archives de la
                GRC, elle pourra être consultée par certaines autorités ou en
                cas de procédure judiciaire, mais ne sera pas accessible dans le
                cadre d'une vérification standard.
            </p>
            <h3>
                <strong>Pourquoi faire une demande de pardon ?</strong>
            </h3>
            <p>
                La demande de pardon permet à la personne coupable de prendre
                ses responsabilités en main tout en allégeant les conséquences
                de l’infraction commise. Bien que la demande de pardon ne
                supprime pas l'infraction elle-même, elle offre plusieurs
                avantages significatifs!
            </p>
            <h4>
                <strong>
                    Voici les principales raisons pour lesquelles il est
                    important de faire une demande de pardon:
                </strong>
            </h4>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Avantages du pardon</strong>
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Explication</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Faciliter l’obtention d’un emploi</p>
                    </td>
                    <td>
                        <p>
                            Le casier judiciaire peut avoir un impact direct sur
                            l’obtention d'un emploi.
                        </p>
                        <p>
                            Dans plusieurs domaines, notamment ceux impliquant
                            un contact avec le public ou régies par des normes
                            de sécurité strictes (comme la santé ou les
                            finances), le casier judiciaire est un frein
                            considérable.
                        </p>
                        <p>
                            À moins que l’infraction ait un lien direct avec
                            votre emploi, l’employeur ne peut techniquement pas
                            refuser de vous employer. Toutefois, la majorité
                            reste réticente face à une telle situation.{' '}
                        </p>
                        <p>
                            Le pardon permet de lever cette barrière en rendant
                            l'infraction inaccessible lors des vérifications de
                            casier judiciaire.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Faciliter l’accès à la location d’un logement</p>
                    </td>
                    <td>
                        <p>
                            Un casier judiciaire peut affecter la capacité de
                            louer un logement. Plusieurs propriétaires
                            effectuent des vérifications de casier judiciaire
                            avant de signer un bail de logement..
                        </p>
                        <p>
                            Il n’est pas illégal pour un locateur de discriminer
                            un candidat en lui refusant un logement en raison de
                            son casier judiciaire, même si la condamnation pour
                            conduite avec facultés affaiblies remonte à
                            plusieurs années.
                        </p>
                        <p>
                            Le pardon permet de contourner cette situation.
                            L’individu aura de meilleures chances d’accéder à un
                            logement, sans être jugé pour son passé.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Faciliter les voyages à l’international</p>
                    </td>
                    <td>
                        <p>
                            Les personnes avec un casier judiciaire peuvent
                            rencontrer des difficultés lorsqu’elles souhaitent
                            voyager à l'étranger.
                        </p>
                        <p>
                            Certains pays, notamment les États-Unis, sont
                            particulièrement stricts en matière d'immigration et
                            refusent l’entrée à toute personne ayant un casier
                            judiciaire, même si l'infraction est mineure ou a
                            été commise il y a plusieurs années.
                        </p>
                        <p>
                            Le pardon va vous permettre de faciliter les
                            déplacements à l’international.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Obtenir un pardon facilite les voyages à l’international!"
                    alt=""
                />
            </p>
            <p>
                Faire une demande de pardon permet de ré
                <strong>
                    duire les impacts négatifs d’un casier judiciaire
                </strong>{' '}
                et de se réintégrer pleinement dans la société.{' '}
                <strong>Le processus de demande de pardon!</strong>
            </p>
            <p>
                Avant d'entreprendre la procédure de demande de pardon, il est
                important de comprendre les différentes étapes à suivre, les
                critères d'admissibilité et les documents nécessaires !
            </p>
            <h3>
                <strong>Vérification de l’éligibilité</strong>
            </h3>
            <p>
                Avant de commencer la demande de pardon, il faut vérifier si
                vous êtes éligible.
            </p>
            <p>
                En vertu de la{' '}
                <Link to="https://laws-lois.justice.gc.ca/fra/lois/C-47/">
                    Loi sur le casier judiciaire
                </Link>
                , nul n’est admissible à présenter une demande de suspension du
                casier (demande de pardon) avant que l
                <strong>
                    a période consécutive à l’expiration légale de la peine
                </strong>
                , notamment une peine d’emprisonnement, une période de probation
                ou le paiement d’une amende, énoncée ci-après, ne soit écoulée :
            </p>
            <ul>
                <li>
                    10 ans pour conduite avec les facultés affaiblies par
                    l’alcool qui a fait l’objet d’une poursuite par voie de mise
                    en accusation.
                </li>
                <li>
                    5 ans pour conduite avec les facultés affaiblies par
                    l’alcool qui est punissable sur déclaration de culpabilité
                    par procédure sommaire.
                </li>
            </ul>
            <p>
                Si vous avez été condamné pour conduite avec facultés
                affaiblies, vous devrez <strong>attendre 5 ou 10 ans </strong>
                après avoir purgé votre peine avant de présenter une demande de
                pardon.{' '}
            </p>
            <p>
                L’attente sera de 5 ans lorsque l'infraction a été jugée par
                procédure sommaire, tandis qu'une mise en accusation nécessitera
                10 ans avant de pouvoir commencer la démarche.
            </p>
            <h3>
                <strong>Collecte des documents nécessaires</strong>
            </h3>
            <p>
                Pour préparer votre demande de pardon, il faut rassembler
                plusieurs documents afin de compléter votre dossier. Cela peut
                sembler compliqué, mais chaque document à son rôle spécifique
                dans le processus.
            </p>
            <ul>
                <li>
                    <strong>Le casier judiciaire : </strong>Il faut obtenir
                    votre casier judiciaire auprès de la Gendarmerie royale du
                    Canada. Il faudra alors se présenter à un poste de police et
                    donner vos empreintes digitales.
                </li>
                <li>
                    <strong>La preuve de condamnation :</strong> Si l’infraction
                    n’apparaît pas directement sur votre casier judiciaire, vous
                    devrez fournir un document officiel de la cour qui prouve
                    votre condamnation (notamment une copie du jugement).
                </li>
                <li>
                    <strong>Les informations de la cour :</strong> Vous devrez
                    fournir les détails concernant votre condamnation (les
                    peines prononcées et la date de la condamnation).
                </li>
            </ul>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Le processus de demande de pardon!"
                    alt=""
                />
            </p>
            <ul>
                <li>
                    <strong>Les vérifications de police locale :</strong> Selon
                    les endroits où vous avez vécu dans les cinq dernières
                    années, vous devrez fournir des vérifications des dossiers
                    de police locale.
                </li>
                <li>
                    <strong>Photocopie d’une pièce d’identité : </strong>Vous
                    devrez fournir une copie d’un document d'identité valide,
                    comme un passeport ou un permis de conduire.
                </li>
                <li>
                    <strong>Autres vérifications :</strong> Si vous avez servi
                    dans les Forces armées canadiennes, un rapport de conduite
                    militaire est nécessaire, ainsi que d’autres documents en
                    fonction de votre situation.
                </li>
            </ul>
            <h3>
                <strong>Préparation des formulaires requis</strong>
            </h3>
            <p>
                Une fois que vous avez rassemblé tous les documents nécessaires,
                vous pouvez passer à la prochaine étape : remplir les
                formulaires pour votre demande de pardon.
            </p>
            <h4>
                <strong>
                    Le formulaire de demande de suspension du casier judiciaire
                </strong>
            </h4>
            <p>
                Ce formulaire, que vous pouvez obtenir auprès de la Commission
                des libérations conditionnelles du Canada, vous demande de
                fournir <strong>des informations personnelles: </strong>
            </p>
            <ul>
                <li>Votre nom</li>
                <li>Votre date de naissance</li>
                <li>Votre sexe</li>
                <li>Votre numéro de permis de conduire (si applicable)</li>
                <li>
                    Votre adresse actuelle et les adresses précédentes des dix
                    dernières années
                </li>
            </ul>
            <p>
                Il faut veiller à ce que toutes les informations soient
                complètes et exactes afin d'éviter tout retard ou rejet de votre
                demande.
            </p>
            <h4>
                <strong>Le formulaire Bénéfice mesurable/réadaptation</strong>
            </h4>
            <p>
                Ce formulaire permet de démontrer que la suspension de votre
                casier judiciaire vous{' '}
                <strong>apportera des bénéfices concrets</strong>. Vous devrez
                expliquer en détail comment cela contribuera à votre
                réintégration dans la société, en tant que citoyen respectueux
                des lois.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            L'objectif est de prouver que vous avez
                            véritablement changé et que cette demande de pardon
                            n'est pas simplement une démarche pour faciliter
                            votre vie!
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Pour démontrer vos efforts de réadaptation, vous devez prouver
                que vous avez travaillé sur votre réhabilitation (vous avez
                participé à des programmes de soutien par exemple).
            </p>
            <p>
                Vous pouvez également fournir des lettres de référence
                d’employeurs ou de professionnels qui attestent de votre bonne
                conduite et de vos efforts.
            </p>
            <h3>
                <strong>Soumettre la demande et attendre</strong>
            </h3>
            <p>
                Une fois le dossier complet, vous pouvez soumettre votre demande
                à la Commission des libérations conditionnelles du Canada.
            </p>
            <p>
                À cette étape, des frais de traitement seront appliqués,{' '}
                <strong>généralement autour de 50$</strong>. Le processus peut
                prendre de 6 à 12 mois, voire plus, selon la complexité de votre
                dossier et les vérifications nécessaires.
            </p>
            <h3>
                <strong>Traitement de la demande et réponse</strong>
            </h3>
            <p>
                La dernière étape de la procédure de demande de pardon consiste
                en l'examen et le traitement de votre demande par la Commission
                des libérations conditionnelles du Canada. Elle évalue plusieurs
                critères avant de rendre sa décision.
            </p>
            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Traitement de la demande de pardon par la Commission!"
                    alt=""
                />
            </p>
            <h4>
                <strong>Durée écoulée depuis la condamnation</strong>
            </h4>
            <p>
                La Commission vérifie que suffisamment de temps s'est écoulé
                depuis votre condamnation et que vous avez purgé toutes les
                peines imposées, y compris toute période de probation ou
                d'amende.
            </p>
            <h4>
                <strong>Comportement depuis la condamnation</strong>
            </h4>
            <p>
                Votre comportement depuis la condamnation est scruté à la loupe.
                Si vous avez maintenu une conduite irréprochable, sans nouvelles
                infractions criminelles, et si vous avez participé à des
                programmes de réhabilitation, cela renforcera considérablement
                votre demande.{' '}
            </p>
            <p>
                En revanche, toute infraction postérieure pourrait nuire à la
                recevabilité de votre dossier.
            </p>
            <h4>
                <strong>
                    Les circonstances entourant la commission de l’infraction
                </strong>
            </h4>
            <p>
                Les circonstances spécifiques de l'infraction sont prises en
                compte. Par exemple, la Commission peut examiner des éléments
                tels que:
            </p>
            <ul>
                <li>Votre taux d’alcool au moment de l'infraction, </li>
                <li>
                    Votre attitude avec les policiers au moment de
                    l’arrestation, ainsi que{' '}
                </li>
                <li>
                    La présence d'autres passagers dans le véhicule, en
                    particulier des personnes vulnérables, comme des enfants.
                </li>
            </ul>
            <p>
                Ces facteurs peuvent jouer un rôle important dans l’évaluation
                de la gravité de l'infraction et, par conséquent, dans la
                décision concernant votre demande de pardon.
            </p>
            <h4>
                <strong>Évaluation de l'administration de la justice</strong>
            </h4>
            <p>
                La Commission évalue si la suspension du casier judiciaire
                pourrait compromettre l’administration de la justice. Elle
                considère la gravité de l’infraction, la durée de la peine et
                les circonstances qui l’entourent pour déterminer si la demande
                de pardon peut être accordée.{' '}
            </p>
            <p>
                <strong>
                    Si tous ces éléments sont favorables, votre demande de
                    pardon sera acceptée.
                </strong>
            </p>
            <h2>
                <strong>
                    Vous désirez obtenir un pardon ? Consultez un avocat
                    spécialisé en droit criminel !
                </strong>
            </h2>
            <p>
                Bien que vous puissiez soumettre une demande de pardon
                vous-même, il est fortement recommandé de travailler avec un
                avocat spécialisé en droit criminel.
            </p>
            <p>
                Un avocat pourra vous guider dans la collecte des documents
                nécessaires, s’assurer que tous les formulaires sont
                correctement remplis et vous donner des conseils précieux sur la
                manière de présenter votre demande de la manière la plus
                convaincante possible.
            </p>
            <p>
                <Img
                    fluid={data.img5.childImageSharp.fluid}
                    title="Avocat pour demande de pardon!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Grâce à notre formulaire simple et gratuit, vous pourrez
                    rapidement trouver un avocat spécialisé en droit criminel
                    pour vous accompagner dans votre demande de pardon !
                </strong>
            </p>
            <p>
                <strong>
                    Après avoir soumis votre demande, nous vous mettrons en
                    relation avec un avocat proche de chez vous. Ce service ne
                    vous engage en rien !
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "obtenir-pardon-alcool-volant-quebec/demande-pardon-conduite-facultes-affaiblies.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "obtenir-pardon-alcool-volant-quebec/pourquoi-faire-demande-pardon.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "obtenir-pardon-alcool-volant-quebec/obtenir-pardon-facilite-voyages-international.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "obtenir-pardon-alcool-volant-quebec/processus-demande-pardon.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "obtenir-pardon-alcool-volant-quebec/demande-pardon-commission-libération-conditionnelles.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img5: file(
            relativePath: {
                eq: "obtenir-pardon-alcool-volant-quebec/avocat-demande-pardon-quebec.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
